import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import loginDf2c2a from './login'
import enroll47ba96 from './enroll'
import challengeF9272e from './challenge'
import recoveryA63da9 from './recovery'
import users from './users'
import staff from './staff'
import blog from './blog'
/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/auth/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::login
* @see app/Domain/Org/Http/Controllers/AuthController.php:22
* @route '//org.launchstation.app/auth/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
export const enroll = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})

enroll.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/auth/enroll',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
enroll.url = (options?: RouteQueryOptions) => {
    return enroll.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
enroll.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
enroll.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: enroll.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
const enrollForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
enrollForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::enroll
* @see app/Domain/Org/Http/Controllers/AuthController.php:51
* @route '//org.launchstation.app/auth/enroll'
*/
enrollForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

enroll.form = enrollForm

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
export const challenge = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: challenge.url(options),
    method: 'get',
})

challenge.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/auth/challenge',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
challenge.url = (options?: RouteQueryOptions) => {
    return challenge.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
challenge.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
challenge.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: challenge.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
const challengeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
challengeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::challenge
* @see app/Domain/Org/Http/Controllers/AuthController.php:92
* @route '//org.launchstation.app/auth/challenge'
*/
challengeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

challenge.form = challengeForm

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::logout
* @see app/Domain/Org/Http/Controllers/AuthController.php:149
* @route '//org.launchstation.app/auth/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/auth/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::logout
* @see app/Domain/Org/Http/Controllers/AuthController.php:149
* @route '//org.launchstation.app/auth/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::logout
* @see app/Domain/Org/Http/Controllers/AuthController.php:149
* @route '//org.launchstation.app/auth/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::logout
* @see app/Domain/Org/Http/Controllers/AuthController.php:149
* @route '//org.launchstation.app/auth/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::logout
* @see app/Domain/Org/Http/Controllers/AuthController.php:149
* @route '//org.launchstation.app/auth/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\DashboardController::__invoke
* @see app/Domain/Org/Http/Controllers/DashboardController.php:14
* @route '//org.launchstation.app'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
export const recovery = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recovery.url(options),
    method: 'get',
})

recovery.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/auth/recovery-codes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
recovery.url = (options?: RouteQueryOptions) => {
    return recovery.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
recovery.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
recovery.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: recovery.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
const recoveryForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
recoveryForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::recovery
* @see app/Domain/Org/Http/Controllers/AuthController.php:134
* @route '//org.launchstation.app/auth/recovery-codes'
*/
recoveryForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

recovery.form = recoveryForm

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
export const activity = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(options),
    method: 'get',
})

activity.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/activity',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
activity.url = (options?: RouteQueryOptions) => {
    return activity.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
activity.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
activity.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: activity.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
const activityForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
activityForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Org\Http\Controllers\ActivityController::__invoke
* @see app/Domain/Org/Http/Controllers/ActivityController.php:11
* @route '//org.launchstation.app/activity'
*/
activityForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

activity.form = activityForm

const org = {
    login: Object.assign(login, loginDf2c2a),
    enroll: Object.assign(enroll, enroll47ba96),
    challenge: Object.assign(challenge, challengeF9272e),
    logout: Object.assign(logout, logout),
    dashboard: Object.assign(dashboard, dashboard),
    recovery: Object.assign(recovery, recoveryA63da9),
    users: Object.assign(users, users),
    staff: Object.assign(staff, staff),
    activity: Object.assign(activity, activity),
    blog: Object.assign(blog, blog),
}

export default org